import React, {useEffect} from "react";
import { useLocation } from 'react-router-dom';
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Team from "./Team";

function About() {

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [location]); // Re-run effect when the location (including hash) changes

  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row className="about-row-custom flex-row-reverse flex-md-row about-row-desktop" style={{ justifyContent: "left", padding: "10px", position: 'relative' }}>
          <Col
            md={5}
            className="about-img about-img-overlay order-2 order-md-2"
            style={{
              paddingTop: "120px",
              paddingBottom: "50px",
              position: 'absolute',
              right: 0,
              bottom: 0,
              zIndex: 1,
              height: '100%',
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'flex-end',
            }}
          >
            <img src={laptopImg} alt="about" className="img-fluid" style={{ objectFit: 'contain', height: '100%', width: 'auto', maxWidth: '100%' }} />
          </Col>
          <Col
            md={7}
            className="about-content-col order-1 order-md-1"
            style={{
              justifyContent: "flex-start",
              paddingTop: "30px",
              paddingBottom: "50px",
              zIndex: 2,
            }}
          >
            <Aboutcard />
          </Col>
        </Row>
        
        <h1 className="project-heading" id="team-section">
          <strong className="purple">Team </strong>
        </h1>

        <Team />

        
      </Container>
    </Container>
  );
}

export default About;
